<template>
  <div class="search-box" @click="onClickSearch">
    <Icon name="search"/>
    <div class="search-desc">大家都在看</div>
  </div>
</template>

<script>

  import {Icon} from "vant"

  export default {
    name: "SearchBoxIcon",
    props: {
      itemType: {
        type: String,
        default: "",
      }
    },
    components: {
      Icon
    },
    methods: {
      onClickSearch() {
        this.$router.push({
          "path": '/search',
          "query": {
            "item_type": this.itemType,
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>

  .search-box {
    display: flex;
    align-items: center;
    padding: 10px 5px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
    flex: 0 0 auto;
    background: #f2f2f2;

    .search-desc {
      color: grey;
      font-size: 12px;
      margin-left: 5px;
    }
  }
</style>
